import React from 'react'
import SignIn from '../components/Signin'

const SigninPage = () => {
  return (
    <div><SignIn /></div>
  )
}

export default SigninPage